// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2Vkrv","label":"Category_label__2zdj2","content":"Category_content__195Bk","header":"Category_header__1ZrSK","location":"Category_location__MJn8R"};